import React from 'react';

import Header from '../../layout/Header.jsx';
import ListSchools from '../../lists/ListSchools.jsx';

const PageSchools = () => (
  <div>
    <Header>Schools</Header>
    <ListSchools />
  </div>
);

export default PageSchools;
